import { recipe } from "@vanilla-extract/recipes";

export const centeredStyle = recipe({
  base: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    textAlign: "center",
  },
  variants: {
    horizontal: {
      true: {
        height: "auto",
      },
    },
    grow: {
      true: {
        flexGrow: 1,
      },
    },
  },
});
